module.exports = __webpack_public_path__ + "static/media/stripe.875a4de7.svg";